import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { GetPathPrefix } from './utils/api';
import Disclosure from './pages/Disclosure';
import SetupTips from './pages/SetupTips';
import Auth from './pages/Auth';
import Chat from './pages/Chat';
import EdwardNashton from './pages/EdwardNashton';
import ClosedDoor from './pages/ClosedDoor';

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="boot-screen">
        <div className="boot-mark">?</div>
        <p>Opening the puzzle box…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

function GuestOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="boot-screen">
        <div className="boot-mark">?</div>
      </div>
    );
  }
  if (user) return <Navigate to="/chat" replace />;
  return children;
}

function ServiceWorkerBridge() {
  const navigate = useNavigate();
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return undefined;
    const OnMessage = (event) => {
      if (event?.data?.type === 'riddler:focus-chat') {
        navigate('/chat');
      }
    };
    navigator.serviceWorker.addEventListener('message', OnMessage);
    return () => navigator.serviceWorker.removeEventListener('message', OnMessage);
  }, [navigate]);
  return null;
}

export default function AppRouter() {
  const basename = GetPathPrefix() || undefined;

  return (
    <BrowserRouter basename={basename}>
      <ServiceWorkerBridge />
      <Routes>
        <Route path="/" element={<GuestOnly><Disclosure /></GuestOnly>} />
        <Route path="/setup" element={<GuestOnly><SetupTips /></GuestOnly>} />
        <Route path="/auth" element={<GuestOnly><Auth /></GuestOnly>} />
        <Route path="/chat" element={<Protected><Chat /></Protected>} />
        <Route path="/Edward-Nashton" element={<EdwardNashton />} />
        <Route path="/edward-nashton" element={<EdwardNashton />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
